<div [ngBusy]="busy">
    <customer-connect [opportunity]="opportunity" [customer]="opportunity?.customer" [users]="users"
        [permissions]="permissions" [maxScheduleFutureDays]="opportunity?.dealerSettings?.maxScheduleFutureDays"
        [defaultCustomerConnectAction]="defaultCustomerConnectAction" [isCustomerConnectOpen]="isCustomerConnectOpen"
        [isEuroLite]="false" [isTextingEnabled]="false" [mobileView]="true"
        (onLogScheduleSubmit)="onLogScheduleSubmit($event)"
        (onCustomerEdit)="updateCustomer($event.$value)">
    </customer-connect>
</div>